import { Component, OnInit, OnDestroy } from '@angular/core';
import { LookupDetail } from '../../models/lookup-detail.model';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EntityListRefresh } from '../../services/entity-list.refresh';
import { ProgressBarService } from '../../services/progress-bar.service';
import { LookupCriteria } from '../../models/lookup.criteria';
import { LookupService } from '../../services/lookup.service';
import { Pagination } from '../../models/pagination.model';
import { SortItem } from '../../models/sort-item.model';
import { Subscription } from "rxjs";
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-basic-lookup',
  templateUrl: './basic-lookup.component.html',
  styleUrls: ['./basic-lookup.component.css']
})
export class BasicLookupComponent implements OnInit, OnDestroy {

  entityList: LookupDetail[] = [];
  pagination: Pagination;
  refreshSubscription: Subscription;
  entityName: string = 'lookup';
  criteria: LookupCriteria = new LookupCriteria();
  lookupType: string;
  lookoupTitle: string;
  sortItems: SortItem[] = [
    {
      title: 'ID',
      code: 'id',
      sortOrder: 'asc',
      width: 100,
      disabled: true,
      isEmpty: false,
      class: null
    },
    {
      title: 'Kód',
      code: 'code',
      sortOrder: 'asc',
      width: 156,
      disabled: true,
      isEmpty: false,
      class: null
    },
    {
      title: 'Titulek',
      code: 'title',
      sortOrder: 'asc',
      width: 210,
      disabled: true,
      isEmpty: false,
      class: null
    },
    {
      title: 'Popis',
      code: 'description',
      sortOrder: 'asc',
      width: 210,
      disabled: true,
      isEmpty: false,
      class: null
    },
    {
      title: 'Akce',
      code: 'action',
      sortOrder: 'asc',
      width: 50,
      disabled: true,
      isEmpty: true,
      class: null
    }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private lookupService: LookupService,
    private entityListRefresh: EntityListRefresh,
    private progressBarService: ProgressBarService
  ) { }

  ngOnInit() {
    this.refreshSubscription = this.entityListRefresh.refresh$.subscribe((entityName: string) => {
      if (this.entityName === entityName) {
        this.reloadData();
      }
    });

    this.pagination = <Pagination>JSON.parse(this.route.snapshot.data.lookupList.headers.get('x-pagination'));
    this.entityList = this.route.snapshot.data.lookupList.body;
    this.lookupType = this.route.snapshot.paramMap.get('type');
    this.getTitle(this.lookupType);

    // pokud se zmeni parametry
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // this._activatedRoute.snapshot is up to date
        this.pagination = <Pagination>JSON.parse(this.route.snapshot.data.lookupList.headers.get('x-pagination'));
        this.entityList = this.route.snapshot.data.lookupList.body;
        this.lookupType = this.route.snapshot.paramMap.get('type');
        this.getTitle(this.lookupType);
      }
    });
    
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.refreshSubscription.unsubscribe();
  }

  getTitle(type: string) {
    switch (type) {
      case 'LiftType': {
        this.lookoupTitle = 'Typy výtahu'; 
        break;
      }
      case 'LiftEngine': {
        this.lookoupTitle = 'Motory výtahu';
        break;
      }
      default: {
        this.lookoupTitle = 'Číselník';
        break;
      }
    } 
  }

  reloadData() {
    this.progressBarService.start();
    this.lookupService.get(this.criteria.paramsExport(), this.lookupType)
      .subscribe((response: HttpResponse<LookupDetail[]>) => {
        this.pagination = <Pagination>JSON.parse(response.headers.get('x-pagination'));
        this.entityList = <LookupDetail[]>response.body;
        this.progressBarService.end();
      });
  }

  onSort(sortTerm: string) {
    this.criteria.orderby = sortTerm;
    this.reloadData();
  }

  prevPage() {
    this.criteria.page = this.pagination.page - 1;
    this.reloadData();
  }

  nextPage() {
    this.criteria.page = this.pagination.page + 1;
    this.reloadData();
  }

  goToPage(page: number) {
    this.criteria.page = page;
    this.reloadData();
  }

  createItem() {
    this.router.navigate([{ outlets: { modal: ['create-lookup', this.lookupType] } }]);
  }

  showDetail(id: number) {
    this.router.navigate([{ outlets: { modal: ['lookup-detail', this.lookupType, id] } }]);
  }

}
